import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from '../services/reports.service';

@Component({
    template: ``,
    standalone: false
})
export class ShareReportRedirectComponent implements OnInit {
  private reportHash: string = '';
  private isPublisherShare: boolean = false;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private reportsService: ReportsService
  ) {}

  ngOnInit(): void {
    // Check if this is a publisher share by looking at the URL
    this.isPublisherShare = this.router.url.startsWith('/#/p/report/share') || 
                           this.router.url.includes('/p/report/share');

    this.route.params.subscribe(params => {
      this.reportHash = params['id'];
      if (this.reportHash) {
        this.loadSharedReport();
      }
    });
  }

  private loadSharedReport(): void {
    this.reportsService.getSharedReportByHash(this.reportHash).subscribe({
      next: (sharedReport) => {
        if (this.isPublisherShare) {
          this.handlePublisherRedirect(sharedReport);
        } else {
          this.handleRegularRedirect();
        }
      },
      error: (err) => {
        console.error('Error loading shared report:', err);
        // Fallback to regular reports explorer on error
        this.router.navigate(['/reports-explorer']);
      }
    });
  }

  private handlePublisherRedirect(sharedReport: any): void {
    // Use the publisherId and publisherSecondaryId directly from the API response
    const publisherId = sharedReport.publisherId;
    const publisherSecondaryId = sharedReport.publisherSecondaryId;
    
    if (publisherId && publisherSecondaryId) {
      // Redirect to the publisher reports with the shared report hash
      this.router.navigate(['/p', publisherId, publisherSecondaryId, 'reports', this.reportHash]);
    } else {
      console.warn('Publisher information not found in shared report, redirecting to main reports');
      // Fallback to regular reports explorer if publisher info is not available
      this.router.navigate(['/reports-explorer/shared', this.reportHash]);
    }
  }

  private handleRegularRedirect(): void {
    this.router.navigate(['/reports-explorer/shared', this.reportHash]);
  }
}